import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  TechnicianInventoryOverviewResult,
  TechnicianInventoryResult,
  TechnicianInventoryUpdateRequest,
  TechnicianItemListResult
} from '../models/technician-item.model';

@Injectable({ providedIn: 'root' })
export class TechnicianItemService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  getTechnicianItems(): Observable<TechnicianItemListResult> {
    return this.http.get<TechnicianItemListResult>(`${this.baseUrl}/technician-items`);
  }

  getTechnicianInventory(technicianId: number): Observable<TechnicianInventoryResult> {
    return this.http.get<TechnicianInventoryResult>(`${this.baseUrl}/technicians/${technicianId}/inventory`);
  }

  updateTechnicianInventory(technicianId: number, request: TechnicianInventoryUpdateRequest): Observable<TechnicianInventoryResult> {
    return this.http.put<TechnicianInventoryResult>(`${this.baseUrl}/technicians/${technicianId}/inventory`, request);
  }

  getAllTechnicianInventory(): Observable<TechnicianInventoryOverviewResult> {
    return this.http.get<TechnicianInventoryOverviewResult>(`${this.baseUrl}/technician-inventory`);
  }
}
